import { isErrorCode as E, getDetailsErrorCode as y } from "@waitroom/braid";
import { authBaseEndpoint as _, httpService as O, braidService as V } from "@waitroom/common-api";
import { bearerValue as u } from "@waitroom/http-client";
import { LOGGER_SERVICE_BRAID as k, ERROR_SESSION_ACCESS_UNAUTHORIZED_LOCKED as w, LOGGER_SERVICE_AUTH as m } from "@waitroom/models";
import { withLock as z } from "@waitroom/utils";
import { logger as r } from "./config.es.js";
import { refreshTokenLockName as I } from "./constants.es.js";
import { authService as S } from "./service.es.js";
const A = () => {
  const i = S.getStorageTokens();
  return i != null && i.accessToken ? [S.isTokenValid(i.accessToken, 30), i] : [!1, void 0];
};
var p;
const b = z(
  I,
  async (i) => {
    var n;
    (n = r) == null || n.logService(m, 3, "Refresh token interceptor lock");
    const [s, t] = A();
    if (s || !(t != null && t.refreshToken))
      return t == null ? void 0 : t.accessToken;
    const e = await S.refresh(t.refreshToken);
    if (e != null && e.accessToken)
      return i == null || i(e), e.accessToken;
  },
  { timeout: 8e3, onTimeout: (p = r) == null ? void 0 : p.report }
), l = async (i, s) => {
  const [t, e] = A();
  return t && i !== u(e.accessToken) ? e.accessToken : b(s);
}, v = E([401]), T = E([404]), N = ({ onAuthUpdated: i }) => async (s, t) => {
  var e, n;
  if ((e = r) == null || e.logService(k, 3, "Error interceptor", s.key, t), !s._retry && v(t)) {
    const c = await l((n = s.headers) == null ? void 0 : n.Authorization, i);
    return c ? (s._retry = !0, s.headers = {
      ...s.headers,
      Authorization: u(c)
    }, !0) : !1;
  }
  return !1;
}, B = ({ onAuthUpdated: i }) => async (s, t) => {
  var e, n, c;
  if ((e = r) == null || e.logService(k, 3, "Retry interceptor", s.key, t), v(t)) {
    if (s._retry || y(t) === w)
      return !1;
    const o = await l((n = s.headers) == null ? void 0 : n.Authorization, i);
    if (!o) return !1;
    s._retry = !0, s.headers = {
      ...s.headers,
      Authorization: u(o)
    };
  }
  return (c = r) == null || c.logService(k, 3, "is404", T(t), t), !T(t);
}, H = ({ onRetry: i, onAuthUpdated: s }) => async (t) => {
  var c, o, a, f;
  i == null || i(t);
  const e = t == null ? void 0 : t.config;
  if ((c = r) == null || c.logService(
    m,
    3,
    "Axios auth interceptor",
    t,
    e.url,
    e._retry
  ), ((o = t == null ? void 0 : t.response) == null ? void 0 : o.status) === 401 && !(e != null && e._retry) && !String(e.url).startsWith(_)) {
    e._retry = !0;
    const h = (a = e.headers.Authorization) == null ? void 0 : a.toString(), d = await l(h, s);
    return (f = r) == null || f.logService(m, 3, "Axios auth interceptor", !!d), d ? (e.headers.Authorization = u(d), O.client(e)) : Promise.reject(t);
  }
  return Promise.reject(t);
}, W = ({ onRetry: i, onAuthUpdated: s }) => async (t, e) => {
  var o, a;
  i == null || i(e);
  const n = t;
  if ((e && typeof e == "object" ? (e == null ? void 0 : e.code) || (e == null ? void 0 : e.status) : e) === 401 && !(n != null && n.retried) && !String(n.url).startsWith(_)) {
    n.retried = !0;
    const f = (a = (o = n.headers) == null ? void 0 : o.Authorization) == null ? void 0 : a.toString(), h = await l(f, s);
    return h ? (n.headers = {
      ...n.headers,
      Authorization: u(h)
    }, V.fetch(n)) : Promise.reject(e);
  }
  return Promise.reject(e);
};
export {
  H as axiosAuthInterceptor,
  W as braidOnError,
  N as braidOnErrorInterceptor,
  B as braidOnRetryInterceptor,
  l as getAccessToken
};
